// sublimationSizeValidation.js
import * as Yup from "yup";

export const initialValues = {
  tshirt_size: "",
  size_name: "",
  size_no: "",
  upper_size: "",
};

export const validationSchema = Yup.object({
  tshirt_size: Yup.string().required("T-shirt is required"),
  size_name: Yup.string().required("Size Name is required"),
  size_no: Yup.string().required("Size No. is required"),  
  upper_size: Yup.string().required("Upper size is required"),  
});
